import { graphql } from '@/generated/gql';

export const NEGOTIATION_CONTACT_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationContactUpdate($id: UUID!, $contact: TsrctNegotiationCaseSupplierContactInput!) {
    tesseract {
      negotiationCase(id: $id) {
        supplier {
          contact {
            update(data: $contact) {
              id
              firstName
              lastName
              phone
              email
              mobile
              language
            }
          }
        }
      }
    }
  }
`);
